import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import { closeVisibilityAclModal, selectIsVisibilityAclModalOpen, selectVisibilityAclSourceType } from "../../model"
import { TargetType } from "@/shared/api/groups"
import { VisibilityAclModalContent } from "../visibility-acl-modal/visibility-acl-modal-content"

const MODAL_TITLE = 'Управление видимостью ACL'

export const GroupVisibilityACLModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsVisibilityAclModalOpen)
    const sourceType = useAppSelector(selectVisibilityAclSourceType)
    const isGroupModal = isOpen && sourceType === TargetType.GROUP

    if (!isGroupModal) return null

    return (
        <Modal isOpen={true} title={MODAL_TITLE} onRequestClose={() => dispatch(closeVisibilityAclModal())}>
            <VisibilityAclModalContent />
        </Modal>
    )
}
